
import { call, put, takeEvery } from "redux-saga/effects";
import { dotThiApi } from "../../../api/tct/dotThiApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IDotThi } from "../../../model/respone/tct/IDotThi";
import { eDotThiActionIds, IDotThiActionTypes } from "../../action-types/tct/IDotThiActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.toChucThi.dotThi;
export function* dotThiSaga(): any {
    yield takeEvery(eDotThiActionIds.LOAD_START, loadWorker)
    yield takeEvery(eDotThiActionIds.SAVE_START, saveWorker)
    yield takeEvery(eDotThiActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDotThiActionTypes): any {
    const { hoc_ky, nam_hoc } = action.payload as { hoc_ky: number, nam_hoc: string };
    const res: IBaseRespone = yield call(dotThiApi.SelectByHocKyNamHoc, hoc_ky, nam_hoc)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IDotThiActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as IDotThi
    if (payload.id_dot_thi > 0) {
        res = yield call(dotThiApi.Update, payload)
    } else {
        res = yield call(dotThiApi.Insert, payload)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IDotThiActionTypes): any {
    const res: IBaseRespone = yield call(dotThiApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}